import { render, staticRenderFns } from "./credit-management.vue?vue&type=template&id=6737715a"
import script from "./credit-management.vue?vue&type=script&lang=js"
export * from "./credit-management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports